(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-discharge-type', {
                parent: 'entity',
                url: '/type-discharge-type',
                data: {
                    authorities: [],
                    pageTitle: 'TypeDischargeTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-discharge-type/list/type-discharge-type.html',
                        controller: 'TypeDischargeTypeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_DISCHARGE_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_DISCHARGE_TYPE, access);
                }]
            });
    }
})();
